export default "__VITE_ASSET__BPdwRXmS__"